import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=bcfc087a&scoped=true"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"
import style0 from "./SearchField.vue?vue&type=style&index=0&id=bcfc087a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc087a",
  null
  
)

export default component.exports